export default __webpack_public_path__ + "static/media/union.d1fb7551.webp";